const US_COUNTRY_OF_OPERATION = 'US';

/**
 * Whether Fleet programs is available for this organization.
 * The surface is US-only. A record with no country of operation is treated as US.
 * @param countryOfOperation - Market the organization operates in
 * @returns True when the menu and page should be shown
 */
export const isFleetProgramsAvailable = (
  countryOfOperation?: string | null
): boolean =>
  countryOfOperation == null || countryOfOperation === US_COUNTRY_OF_OPERATION;
